import {FC, useState} from 'react';
import {
  SubsystemsNum,
  SubsystemsNumWrapper,
  SystemCardName,
  SystemCardBottomWrapper,
  SystemCardParamsWrapper,
  SystemCardLastChangeWrapper,
  SystemCardWrapper,
} from '@organisms/SystemCard.styles';
import Text from '@atoms/Text';
import {Link} from 'react-router';
import {theme} from '@styles/theme';
import CoverageBlock from '@molecules/CoverageBlock';
import CircleButton from '@atoms/CircleButton';
import {ISystem} from '@types';
import {ERoutes} from '@constants/routes';
import DeleteSystemModal from '@organisms/modals/DeleteSystemModal';
import AddEditSystemModal from '@organisms/modals/AddEditSystemModal';
import {formatLastUpdate} from '@utils/common';

export interface DashboardSystemBlockProps {
  system: ISystem;
}

const SystemCard: FC<DashboardSystemBlockProps> = ({system}) => {
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  return (
    <SystemCardWrapper>
      <SystemCardName>
        <Link to={ERoutes.SYSTEM_DETAILS.replace(':id', String(system.id))}>
          <Text text={system.name} type="captionB" color={theme.colors.accent00} />
        </Link>
      </SystemCardName>
      <CoverageBlock
        autoCoverage={system.auto_coverage}
        manualCoverage={system.test_coverage}
      />
      <SystemCardParamsWrapper>
        <SubsystemsNumWrapper>
          <SubsystemsNum>
            <Text text="Всего подсистем" type="tinyR" color={theme.colors.basic02} />
            <Text text={`${system.subsystems_count || 0}`} type="tinyM" />
          </SubsystemsNum>
          <SubsystemsNum>
            <Text text="Всего модулей" type="tinyR" color={theme.colors.basic02} />
            <Text text={`${system.modules_count || 0}`} type="tinyM" />
          </SubsystemsNum>
        </SubsystemsNumWrapper>
        <SystemCardBottomWrapper>
          <SystemCardLastChangeWrapper>
            <Text text="Последнее изменение" type="tinyR" color={theme.colors.basic02} />
            <Text text={formatLastUpdate(system.last_update || '')} type="tinyM" />
          </SystemCardLastChangeWrapper>
          <CircleButton
            menu={[
              {
                title: 'Редактировать',
                onClick: () => {
                  setShowEditModal(true);
                },
              },
              {
                title: 'Удалить',
                onClick: () => {
                  setShowDeleteModal(true);
                },
                color: theme.colors.signalRed00,
              },
            ]}
          />
        </SystemCardBottomWrapper>
      </SystemCardParamsWrapper>
      <AddEditSystemModal
        isOpened={showEditModal}
        system={system}
        onCloseRequest={() => setShowEditModal(false)}
      />
      <DeleteSystemModal
        isOpened={showDeleteModal}
        system={system}
        onCloseRequest={() => setShowDeleteModal(false)}
      />
    </SystemCardWrapper>
  );
};

export default SystemCard;
